import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { FormField } from '../../redux/types';
import DollarInputField from '../base/DollarInputField/presets/DollarInputField';
import { useTurnOffSaleOptionCallback } from '../hooks';

interface Props {
  className?: string;
}

const OfferDollarInput: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const turnOffSaleOption = useTurnOffSaleOptionCallback();
  const { trigger, setValue, watch } = useFormContext();
  const currentValues = watch();

  return (
    <DollarInputField
      name={FormField.Offer}
      className={className}
      label={t('sellerModal.create.offer.label')}
      placeholder={t('sellerModal.create.offer.placeholder')}
      isRequired={currentValues.sell_as_offer}
      onChange={newValue => {
        newValue && trigger('offer');
        if (newValue) {
          !currentValues.sell_as_offer && setValue('sell_as_offer', true);
        } else if (
          // check the other value of the pair
          // before turning off the whole thing
          !currentValues.duration &&
          currentValues.sell_as_offer
        ) {
          turnOffSaleOption(FormField.SellAsOffer);
        }
      }}
      noBottomSpacing
    />
  );
};

OfferDollarInput.displayName = 'OfferDollarInput';

export default OfferDollarInput;
